import {
    deleteItemFromCollection,
} from "directus/src/operations";

export async function removeEntity(id) {
    try {
        const response = await deleteItemFromCollection("legal_entities", id);
        return response;
    } catch (error) {
        console.error(error);
        throw error;
    }
}